export default "__VITE_ASSET__$FLSkvf0__"